/**
 * CookieBanner Component
 *
 * Visar en cookie-banner vid botten av sidan vid första besök.
 * Acceptans sparas i localStorage så bannern inte visas igen.
 */

import { useState, useEffect } from 'react';

/** Nyckel som sparas i localStorage när gebruikaren accepterar cookies. */
const COOKIE_CONSENT_KEY = 'cookie-consent-accepted';

/**
 * Hämtar den sparade acceptansstatus från localStorage.
 */
function hasAcceptedCookies(): boolean {
  try {
    return localStorage.getItem(COOKIE_CONSENT_KEY) === 'true';
  } catch {
    return false;
  }
}

/**
 * Sparar acceptans i localStorage.
 */
function acceptCookies(): void {
  try {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'true');
  } catch {
    // localStorage kan vara blockerat i privat läge på andra browsrar
  }
}

export function CookieBanner() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Kontroll på klient-sidan, efter första render, för att undvika
    // hydration-mismatch om SSR-stöd läggs till.
    if (!hasAcceptedCookies()) {
      setIsVisible(true);
    }
  }, []);

  if (!isVisible) {
    return null;
  }

  const handleAccept = () => {
    acceptCookies();
    setIsVisible(false);
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 animate-slide-up">
      <div className="bg-white/95 backdrop-blur-sm border-t border-gray-200 shadow-lg">
        <div className="max-w-4xl mx-auto px-4 py-4 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <p className="text-sm text-gray-700 leading-relaxed">
            Denna webbplats använder cookies för att förbättra din upplevelse och för kartfunktionalitet via Google Maps.
          </p>
          <button
            onClick={handleAccept}
            className="btn-primary text-sm py-2 px-5 flex-shrink-0 self-start sm:self-auto"
          >
            Acceptera
          </button>
        </div>
      </div>
    </div>
  );
}
